export default __webpack_public_path__ + "static/media/logo-people-soft.ec2472af.svg";